import React from 'react'

// E-E-A-T content for the About page: who Pulpit is, what it does, why riders
// trust it, and the real company details. Every claim here is verifiable, no
// invented counts. The Google rating links to the real profile.
const WHAT = [
  { t: 'Outstation cabs', d: 'One-way and round-trip intercity trips at a fixed, all-inclusive fare.' },
  { t: 'Airport transfers', d: 'On-time pickups and drops for early flights and late arrivals.' },
  { t: 'City & local rides', d: 'Point-to-point travel within the city, booked in minutes.' },
  { t: 'Corporate travel', d: 'Employee and business travel with proper GST invoices.' },
]

const TRUST = [
  { t: 'Fixed, all-inclusive fares', d: 'GST and driver allowance are built into the price you see. No surge, no haggling; only tolls and permits are extra, at actuals.' },
  { t: 'Verified drivers', d: 'Background-checked, experienced drivers who know the routes across Gujarat and beyond.' },
  { t: 'GST invoices', d: 'Compliant invoices for company and corporate travel, ready when you need them.' },
]

const MainAboutUs = () => {
  return (
    <div className='main-aboutus'>
      <div className='main-aboutus__container'>
        <div className='main-aboutus__box1'>
          <div className='main-aboutus__content'>
            <h1 className='primary__heading'>About <span className='color-secondary'>Pulpit Cabs</span></h1>
            <p className='paragraph'>
              Pulpit Cabs is an intercity and city taxi service operated by Pulpit Mobility, based in
              Gandhinagar, Gujarat. We run one-way and round-trip outstation cabs, airport transfers and
              local rides across Gujarat and into neighbouring states, with fixed, all-inclusive fares
              shown before you pay, verified drivers, and GST invoices for corporate travel.
            </p>
          </div>
          <div className='main-aboutus__content'>
            <h1 className='primary__heading'>Our <span className='color-secondary'>Mission</span></h1>
            <p className='paragraph'>
              The intercity taxi market has long been unorganised and unpredictable on price. Pulpit was
              built to fix that: one honest, all-inclusive fare per route, shown up front, so a rider always
              knows what a trip costs before it begins.
            </p>
          </div>
        </div>
        <div className='main-aboutus__box2'>
          <img src='/images/googleReview.png' alt='Pulpit Cabs Google reviews and customer ratings' className='main-aboutus__img' />
        </div>
      </div>

      <div className='main-aboutus__container' style={{ display: 'block', marginTop: '2rem' }}>
        <h2 className='primary__heading' style={{ marginBottom: '1.4rem' }}>What we <span className='color-secondary'>do</span></h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {WHAT.map((w) => (
            <div key={w.t} className="rounded-2xl border border-[#e6ecea] bg-[#f5f9f8] p-5">
              <h3 className="text-lg font-extrabold text-[#152321]">{w.t}</h3>
              <p className="text-sm text-[#41514f] mt-2 leading-relaxed">{w.d}</p>
            </div>
          ))}
        </div>
      </div>

      <div className='main-aboutus__container' style={{ display: 'block', marginTop: '2.5rem' }}>
        <h2 className='primary__heading' style={{ marginBottom: '1.4rem' }}>Why riders <span className='color-secondary'>trust Pulpit</span></h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <a
            href="https://www.google.com/maps?cid=14744859779437648009"
            target="_blank"
            rel="noreferrer"
            className="rounded-2xl border border-[#d3ecea] bg-white p-5 block no-underline hover:border-[#21a5a0] transition-colors"
          >
            <h3 className="text-lg font-extrabold text-[#152321]">Rated 4.7 on Google</h3>
            <p className="text-sm text-[#41514f] mt-2 leading-relaxed">
              Real riders, real reviews. <span className="text-[#178f89] font-bold underline">Read them on Google &rsaquo;</span>
            </p>
          </a>
          {TRUST.map((r) => (
            <div key={r.t} className="rounded-2xl border border-[#d3ecea] bg-white p-5">
              <h3 className="text-lg font-extrabold text-[#152321]">{r.t}</h3>
              <p className="text-sm text-[#41514f] mt-2 leading-relaxed">{r.d}</p>
            </div>
          ))}
        </div>
      </div>

      <div className='main-aboutus__container' style={{ display: 'block', marginTop: '2.5rem', marginBottom: '1rem' }}>
        <div className="rounded-2xl border border-[#e6ecea] bg-[#f5f9f8] p-6">
          <h2 className='primary__heading' style={{ marginBottom: '0.75rem' }}>Pulpit <span className='color-secondary'>Mobility</span></h2>
          <p className="text-sm text-[#41514f] leading-relaxed">
            Registered office: 305 Capitol Icon, Sargasan, Gandhinagar, Gujarat 382421.<br />
            Phone: <a href="tel:+918052080501" className="text-[#178f89] font-bold">+91 80520 80501</a>
            {' '}&middot; Email: <a href="mailto:info@pulpitcabs.com" className="text-[#178f89] font-bold">info@pulpitcabs.com</a><br />
            Support: <a href="https://support.pulpitcabs.com" target="_blank" rel="noreferrer" className="text-[#178f89] font-bold">support.pulpitcabs.com</a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default MainAboutUs
